<script lang="ts">
    import { useLocation } from "./router/context";

    const { navigate } = useLocation();
</script>

<header class="flex fixed justify-between max-md:justify-center items-center px-18 w-full h-24 bg bg-cover bg-no-repeat z-10">
    <button class="cursor-pointer" onclick={() => navigate('/')}>
        <img src="/img/sap-logo.svg" class="h-10 max-md:hidden object-contain" alt="logo" />
    </button>
    <img src="/img/logo.png" alt="demo logo" class="h-12 object-contain" />
</header>

<style>
    .bg {
        background-image: url('/img/bg2.png');
    }
</style>